

import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid,
    useMediaQuery, useTheme, FormHelperText, Icon, FormControlLabel, Radio, Typography, FormControl, RadioGroup
} from "@material-ui/core";


import CloseIcon from '@material-ui/icons/Close';

import Scrollbars from "rc-scrollbars";


import { InputBaseField } from "../../../../components/InputField/InputField";

import useStyles from './style';
// import { Label } from "@material-ui/icons";
import { PostDataAPI } from "../../../../Services/APIService";

import { useRef, useState } from "react";
import { Label } from "../../../../components/UiElements/UiElements";
import { useLayoutEffect } from "react";
import { useEffect } from "react";
import DialogLoader from "../../../../components/Loader/DialogLoader";
import { formateMdnNumber } from "../../../../components/Common/Extensions";
import { withSnackbar } from "../../../../components/Message/Alert";
import axios from 'axios';
import { allowedAttachmentsImages } from "../../../../components/Common/Extensions";

function AddNewDonorDialog({ handleSuccessClose, handleClose, editItem, isOpen, ...props }) {
    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [selectedDonorType, setselectedDonorType] = useState('organization');
    const [donorTypeTitle, setDonorTypeTitle] = useState('Organization')
    const inputFile = useRef(null);
    const [selectedFile, setSelectedFile] = useState({ file: null, fileToSend: null, fileName: null });

    const [fileName, setFileName] = useState("")
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState({})


    const handleFileUpload = () => {
        inputFile.current.click();
    }

    const commonAttachments = allowedAttachmentsImages();

    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setSelectedFile({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })

    }

    const handleOptionChange = (e) => {
        setselectedDonorType(e.target.value)
        setDonorTypeTitle(e.target.value)
    }

    const Validate = (errorList) => {

        if (!state.donorName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDonorName: true
            }))
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDonorName: false
            }));
        }

        if (!state.einSsnEncrypted) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEinSsnEncrypted: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEinSsnEncrypted: false
            }));
        }


        if (!state.stateTaxNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorStateTaxNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorStateTaxNumber: false
            }));
        }

        if (!state.AddressLine1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddressLine1: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddressLine1: false
            }));
        }

        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
        }

        if (!state.zip) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZip: false
            }));
        }

        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmail: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmail: false
            }));
        }

        
        if (!state.phone) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }


        
        

    }
    const addOrganization = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            const formData = new FormData();

            Object.keys(state).forEach(key => {
                if (state[key] !== undefined && state[key] !== null) {
                    formData.append(key, state[key]);
                }
            });
            formData.append('CertificateFilePath', selectedFile.fileToSend);
            formData.append('CertificateFile', selectedFile.fileToSend)
            formData.append('EntityType', null);

            setIsLoading(true)

            let apiEndpoint = "fdngrantdonor/add";
            if (editItem.length > 0) {
                apiEndpoint = "fdngrantdonor/update";
            }

            PostDataAPI(apiEndpoint, formData).then((result) => {
                setIsLoading(false)
                if (result.success && result.data != null) {
                    if (result.data) {
                        if (editItem.length > 0) {
                            handleSuccessClose("Organization updated successfully.");
                        } else {
                            handleSuccessClose("Organization added successfully.");
                        }

                    }
                    else {
                        handleSuccessClose("Error", "Error adding Organization, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);

            })
        }

    }


    const handleNumberKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isNumber = /\d/.test(keyValue);
        const isSpecialChar = /[^a-zA-Z0-9]/.test(keyValue);
        if (!isNumber || isSpecialChar) {
            event.preventDefault();
        }
    }


    const [state, setState] = useState(editItem ? editItem : {});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleZipCodeChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (value.trim() != '' && value.trim().length > 4) {
            getStateAndCityOnZipCodeChange(value);
        }

    };

    const getStateAndCityOnZipCodeChange = (zipCode) => {
        axios
            .get(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (response.data != null && response.data.places != null && response.data.places.length > 0) {

                    const { state, state_abbreviation, place_name } = removeSpacesFromKeys(response.data.places[0]);

                    setState(prevState => ({
                        ...prevState,
                        ['state']: state_abbreviation,
                        ['city']: place_name
                    }))
                }
            })
            .catch((error) => {
                //console.log('Error fetching location data:', error);
            });
    };

    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };

    useEffect(() => {
        if (editItem) {
            setState(editItem);
        }
    }, [editItem]);

    return (
        <>
            <Dialog
                maxWidth="lg"
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >

                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>
                                Add Donor
                                {/* {state.addressBookId > 0 ? 'Update Address' : 'Add New Address'} */}
                            </Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                    </div>
                </div>

                {isLoading ? <DialogLoader></DialogLoader> : ''}

                <Scrollbars autoHeight autoHeightMax={570}>
                    <div className={classes.content}>
                        <Grid container alignItems="center">
                            <Label size={2} title="Donor Type" />
                            <Grid item xs={10} className={classes.radioInfo}>
                                <FormControl>
                                    <RadioGroup name="donorType"
                                        value={selectedDonorType}
                                        onChange={handleOptionChange}
                                    >
                                        <FormControlLabel value="organization" control={<Radio />} label="Organization" />
                                        <FormControlLabel value="individual" control={<Radio />} label="Individual" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                        </Grid>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6} >
                                <Label size={12} title={`${donorTypeTitle} Name`} />
                                {
                                    selectedDonorType === "organization" ? <InputBaseField
                                        id="donorName"
                                        name="donorName"
                                        type="text"
                                        value={state.donorName}
                                        onChange={handleChange}
                                        placeholder='Organization name'
                                        IsDisabled={false}
                                        MaxLength={80}
                                    /> : <InputBaseField
                                        id="DonorName"
                                        name="DonorName"
                                        type="text"
                                        // value={state.companyName}
                                        onChange={handleChange}
                                        placeholder='Donor Name'
                                        IsDisabled={false}
                                        MaxLength={80}
                                    />
                                }
                                {errorMessages.errorDonorName && !state.donorName ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter organization name
                                </FormHelperText>) : ('')}

                            </Grid>

                            <Grid item xs={12} md={6} >
                                <Label size={12} title="Organization Logo (High res image)" />
                                <input
                                    ref={inputFile}
                                    id="CertificateFilePath"
                                    name="CertificateFilePath"
                                    type="file"
                                    MaxLength={80}
                                    onChange={uploadSingleFile}
                                    style={{ display: "none" }}
                                />
                                <div className={classes.BrowseMain}>
                                    <InputBaseField
                                        type="text"
                                        value={selectedFile.fileName ? selectedFile.fileName : ''}
                                        placeholder={selectedFile.fileName ? selectedFile.fileName : "No File Chosens"}
                                        MaxLength={80}
                                        onChange={(e) => { }}
                                        className={classes.fileInput}
                                        readOnly={true}
                                        onPaste={(e) => e.preventDefault()}
                                        onDrop={(e) => e.preventDefault()}
                                    />
                                    <a className={"BrowseButton"} onClick={handleFileUpload}>
                                        Browse
                                    </a>
                                </div>

                            </Grid>


                        </Grid>

                        <Grid container spacing={4}>

                            <Grid item xs={12} md={6}>
                                <Label size={12} title="EIN" />
                                <InputBaseField
                                    id="einSsnEncrypted"
                                    name="einSsnEncrypted"
                                    type="text"
                                    value={state.einSsnEncrypted}
                                    onChange={handleChange}
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                    placeholder='123456'
                                    IsDisabled={false}
                                    MaxLength={9}
                                />
                                {errorMessages.errorEinSsnEncrypted && !state.einSsnEncrypted ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter organization name
                                </FormHelperText>) : ('')}
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Label size={12} title="State Tax Number" />
                                <InputBaseField
                                    id="stateTaxNumber"
                                    name="stateTaxNumber"
                                    type="text"
                                    value={state.stateTaxNumber}
                                    onChange={handleChange}
                                    placeholder='144145234234'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                    IsDisabled={false}
                                    MaxLength={20}
                                />

                                {errorMessages.errorStateTaxNumber && !state.stateTaxNumber ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter state tax number
                                </FormHelperText>) : ('')}
                            </Grid>

                        </Grid>

                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Email Address" />
                                <InputBaseField
                                    id="email"
                                    name="email"
                                    type="email"
                                    value={state.email}
                                    onChange={handleChange}
                                    placeholder='admin@floridaLocal.com'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                                {errorMessages.errorEmail && !state.email ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter email
                                </FormHelperText>) : ('')}

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Phone Number" />
                                <InputBaseField
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    value={formateMdnNumber(state.phone)}
                                    MaxLength={14}
                                    onChange={handleChange}
                                    placeholder='(386) 253-3707'
                                    IsDisabled={false}
                                />

                                {errorMessages.errorPhone && !state.phone ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter phone
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>


                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Address 1" />
                                <InputBaseField
                                    id="addressLine1"
                                    name="AddressLine1"
                                    type="text"
                                    value={state.AddressLine1}
                                    onChange={handleChange}
                                    placeholder='1441 S Nova Rd, Daytona Beach'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                                {errorMessages.errorAddressLine1 && !state.AddressLine1 ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter address 1
                                </FormHelperText>) : ('')}

                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Address 2" />
                                <InputBaseField
                                    id="AddressLine2"
                                    name="AddressLine2"
                                    type="text"
                                    value={state.AddressLine2}
                                    onChange={handleChange}
                                    placeholder='Address 2'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                            </Grid>
                        </Grid>



                        <Grid container spacing={4}>
                            <Grid item xs={12} md={4}>
                                <Label size={12} title="City" />
                                <InputBaseField
                                    id="city"
                                    name="city"
                                    type="text"
                                    value={state.city}
                                    onChange={handleChange}
                                    placeholder='Florida'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />

                                {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter city
                                </FormHelperText>) : ('')}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Label size={12} title="State" />
                                <InputBaseField
                                    id="state"
                                    name="state"
                                    type="text"
                                    value={state.state}
                                    onChange={handleChange}
                                    placeholder=''
                                    IsDisabled={false}
                                    MaxLength={80}
                                />

                                {errorMessages.errorState && !state.state ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter state
                                </FormHelperText>) : ('')}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Label size={12} title="Zip Code" />
                                <InputBaseField
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    value={state.zip}
                                    onChange={handleZipCodeChange}
                                    placeholder='2112'
                                    IsDisabled={false}
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                    MaxLength={9}
                                />

                                {errorMessages.errorZip && !state.zip ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter zip code
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>

                        {/* <Grid container>
                            <Grid item xs={12}>
                                <Label size={12} title="Organization information" />
                                <InputBaseField
                                    id="companyInformation"
                                    name="Company Information"
                                    type="text"
                                    // value={state.firstName}
                                    onChange={handleChange}
                                    placeholder='Company information'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                            </Grid>


                        </Grid> */}


                        <h3 className={classes.subHeading}>Contact Person Information</h3>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Name" />
                                <InputBaseField
                                    id="ContactPersonName"
                                    name="ContactPersonName"
                                    type="text"
                                    value={state.ContactPersonName}
                                    onChange={handleChange}
                                    placeholder='john doe'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Email Address" />
                                <InputBaseField
                                    id="ContactPersonEmail"
                                    name="ContactPersonEmail"
                                    type="email"
                                    value={state.ContactPersonEmail}
                                    onChange={handleChange}
                                    placeholder='admin@floridaLocal.com'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Phone Number" />
                                <InputBaseField
                                    id="ContactPersonPhone"
                                    name="ContactPersonPhone"
                                    type="text"
                                    value={formateMdnNumber(state.ContactPersonPhone)}
                                    MaxLength={14}
                                    onChange={handleChange}
                                    placeholder='(386) 253-3707'
                                    IsDisabled={false}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Label size={12} title="Job Title" />
                                <InputBaseField
                                    id="ContactPersonTitle"
                                    name="ContactPersonTitle"
                                    type="text"
                                    value={state.ContactPersonTitle}
                                    onChange={handleChange}
                                    placeholder='job title'
                                    IsDisabled={false}
                                    MaxLength={80}
                                />
                            </Grid>
                        </Grid>
                    </div>


                </Scrollbars>
                <div className={classes.footer}>
                    <div className={classes.footerRight}>
                        <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                        <Button className={classes.changeBtn} onClick={addOrganization}>Add Donor </Button>

                    </div>
                </div>

            </Dialog>
        </>
    )
}


export default withSnackbar(AddNewDonorDialog);
